import { EditIcon } from '@chakra-ui/icons';
import { TbTrash } from 'react-icons/tb';

import ActionsButton from 'components/tables/AGGrid/ActionsButton';

/**
 * Builds the AG Grid column definitions for the Countries table.
 *
 * @param {object}   params
 * @param {function} params.onEditCountry   Called with the row data when the edit action is clicked.
 * @param {function} params.onDeleteCountry Called with the row data when the delete action is clicked.
 * @returns {Array} AG Grid column definitions.
 */
export const getCountriesTableColumns = ({
    onEditCountry,
    onDeleteCountry,
}) => [
    {
        headerName: 'Name',
        field: 'name',
        flex: 1,
        minWidth: 150,
        sort: 'asc',
    },
    {
        headerName: 'Country Code',
        field: 'countryCode',
        maxWidth: 150,
    },
    {
        headerName: 'Alpha-2',
        field: 'alpha2',
        maxWidth: 110,
    },
    {
        headerName: 'Alpha-3',
        field: 'alpha3',
        maxWidth: 110,
    },
    {
        headerName: 'National Codes',
        field: 'nationalCodes',
        flex: 1,
        minWidth: 180,
        filter: false,
        sortable: false,
        valueFormatter: (params) => params.value?.join(', ') || '',
    },
    {
        headerName: 'Multi-National Codes',
        field: 'multiNationalCodes',
        flex: 1,
        minWidth: 180,
        filter: false,
        sortable: false,
        valueFormatter: (params) => params.value?.join(', ') || '',
    },
    {
        headerName: 'Action',
        maxWidth: 100,
        filter: false,
        suppressMovable: true,
        lockVisible: true,
        suppressColumnsToolPanel: true,
        suppressHeaderMenuButton: true,
        suppressHeaderFilterButton: true,
        enableRowGroup: false,
        resizable: false,
        sortable: false,
        cellStyle: () => ({ display: 'flex', alignItems: 'center' }),
        lockPosition: 'right',
        cellRenderer: (params) => (
            <ActionsButton
                actions={[
                    {
                        label: 'Edit',
                        icon: EditIcon,
                        onClick: () => onEditCountry(params.data),
                    },
                    {
                        label: 'Delete',
                        icon: TbTrash,
                        onClick: () => onDeleteCountry(params.data),
                    },
                ]}
            />
        ),
    },
];
